import { render } from "./Quotes.vue?vue&type=template&id=5a79d3d4&scoped=true"
import script from "./Quotes.vue?vue&type=script&lang=js"
export * from "./Quotes.vue?vue&type=script&lang=js"

import "./Quotes.vue?vue&type=style&index=0&id=5a79d3d4&scoped=true&lang=scss"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a79d3d4"]])

export default __exports__